var map = {
	"./en/1-8/tit_8.png": 1557,
	"./fi/1-8/tit_8.png": 83063,
	"./in/1-8/tit_8.png": 57225,
	"./th/1-8/tit_8.png": 79000,
	"./tw/1-8/tit_8.png": 56531,
	"./zh/1-8/tit_8.png": 62618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96303;